import * as React from "react";
import type { SVGProps } from "react";
const SvgVerifiedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 409.592 409.592"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="m399.643 180.659-27.935-27.93c-6.63-6.63-12.063-19.732-12.063-29.128v-39.5c0-18.79-15.35-34.14-34.135-34.15h-39.516c-9.385 0-22.502-5.443-29.133-12.068l-27.93-27.93c-13.271-13.271-35-13.271-48.271 0l-27.93 27.95c-6.636 6.63-19.768 12.058-29.133 12.058h-39.5c-18.765 0-34.135 15.35-34.135 34.14v39.501c0 9.359-5.432 22.502-12.063 29.128L9.964 180.66c-13.281 13.271-13.281 35 0 48.292l27.935 27.93c6.635 6.63 12.063 19.768 12.063 29.128v39.501c0 18.77 15.37 34.14 34.135 34.14h39.501c9.385 0 22.502 5.432 29.133 12.058l27.93 27.94c13.271 13.261 35 13.261 48.271 0l27.93-27.94c6.636-6.63 19.748-12.058 29.133-12.058h39.516c18.785 0 34.135-15.37 34.135-34.14V286.01c0-9.4 5.437-22.502 12.063-29.128l27.935-27.93c13.26-13.292 13.26-35.022-.001-48.293M177.701 281.6l-75.31-75.32 24.136-24.131 51.18 51.18L283.061 128l24.13 24.131z" />
  </svg>
);
export default SvgVerifiedIcon;
